import type { SyncState } from "../../infrastructure/sync/automerge.ts";
import type { TaskSyncStatus } from "../../domain/app-types.ts";
import type { Todo } from "../../domain/entities.ts";
import { capitalize } from "../../ui/text.ts";

export function updateSyncPillView(container: ParentNode, state: SyncState, label: string): void {
  const needsAttention = state === "attention";
  container.querySelectorAll<HTMLElement>("[data-mobile-sync-warning], [data-mobile-sync-action]").forEach(element => { element.hidden = !needsAttention; });
  const more = container.querySelector<HTMLElement>(".topbar-more");
  more?.classList.toggle("has-sync-warning", needsAttention);
  const moreTrigger = more?.querySelector<HTMLElement>("summary");
  moreTrigger?.setAttribute("title", needsAttention ? "More application actions · Sync needs attention" : "More application actions");
  if (needsAttention) moreTrigger?.setAttribute("aria-description", "Synchronization needs attention. Open this menu for details and retry.");
  else moreTrigger?.removeAttribute("aria-description");
  const pill = container.querySelector<HTMLElement>(".sync-pill");
  if (pill) {
    pill.className = `sync-pill sync-pill--${state}`;
    pill.setAttribute("aria-label", label);
    pill.setAttribute("title", label);
    pill.innerHTML = `<i></i><span>${state === "synced" ? "" : label}</span>`;
  }
  const status = container.querySelector<HTMLElement>("#app-status");
  if (status) status.textContent = label;
}

export function updateTaskSyncViews(container: ParentNode, statuses: ReadonlyMap<string, TaskSyncStatus>, renderBadge: (id: string) => string): void {
  container.querySelectorAll<HTMLElement>("[data-todo]").forEach(row => {
    const id = row.dataset.todo;
    const badge = row.querySelector<HTMLElement>(".task-sync");
    if (id && badge) badge.outerHTML = renderBadge(id);
  });
  container.querySelectorAll<HTMLElement>("[data-task-sync-fact]").forEach(value => {
    const id = value.dataset.taskSyncFact;
    value.textContent = capitalize(id ? statuses.get(id) || "local" : "local");
  });
}

export function updateSubtaskProgressView(container: ParentNode, todo: Todo, subtaskId: string, trigger: HTMLElement): void {
  const subtask = (todo.subtasks || []).find(item => item.id === subtaskId);
  const row = trigger.closest<HTMLElement>(".view-subtask");
  if (subtask && row) {
    row.classList.toggle("is-complete", subtask.completed);
    trigger.setAttribute("aria-pressed", String(subtask.completed));
    trigger.setAttribute("aria-label", `${subtask.completed ? "Mark incomplete" : "Mark complete"}: ${subtask.title}`);
  }
  const completed = (todo.subtasks || []).filter(item => item.completed).length;
  const total = (todo.subtasks || []).length;
  const panelCount = container.querySelector<HTMLElement>(".task-view__section-heading > span");
  if (panelCount) panelCount.textContent = `${completed} of ${total} completed`;
  const listCount = container.querySelector<HTMLElement>(`[data-todo="${CSS.escape(todo.id)}"] .todo-meta span[title*="subtasks complete"]`);
  if (listCount) {
    listCount.textContent = `${completed} of ${total} subtasks`;
    listCount.title = `${completed} of ${total} subtasks complete`;
  }
}
